export default __webpack_public_path__ + "static/media/hero3-bg.dfc8c035.png";